function isErrorRecord(error: unknown): error is Record<string, unknown> {
	return typeof error === "object" && error !== null;
}

/** HTTP status from API client errors when present (e.g. `{ status: 403 }`). */
export function getClientErrorStatus(error: unknown): number | null {
	if (!isErrorRecord(error) || !("status" in error)) {
		return null;
	}
	const status = Number(error.status);
	if (Number.isNaN(status)) {
		return null;
	}
	return status;
}

/** String `message` from API client errors when present. */
export function getClientErrorMessage(error: unknown): string | null {
	if (!isErrorRecord(error) || !("message" in error)) {
		return null;
	}
	const message = error.message;
	if (typeof message !== "string") {
		return null;
	}
	return message;
}
